import { responsiveStyle } from '@synoptic/ui-kit/responsive/responsive-style.ts';
import { space } from '@synoptic/ui-kit/tokens.ts';
import { style } from '@vanilla-extract/css';

export const streamsGrid = style([
  {
    display: 'grid',
  },
  responsiveStyle({
    mobile: {
      gridTemplateColumns: 'repeat(1, minmax(0, 1fr))',
      gap: space.s8,
      gridAutoRows: '305px',
    },
    tablet: {
      gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
      gap: space.s16,
    },
    laptop: {
      gap: space.s8,
      gridTemplateColumns: 'repeat(1, minmax(0, 1fr))',
      gridAutoRows: '97px',
    },
  }),
]);
